import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-mcommerce-virtual-cash-register-card',
  templateUrl: './mcommerce-virtual-cash-register-card.component.html',
  styleUrls: ['./mcommerce-virtual-cash-register-card.component.scss']
})
export class McommerceVirtualCashRegisterCardComponent implements OnInit {

  @Input() data;

  constructor() { }

  ngOnInit() {
  }

}
